import { render } from "./SaveList.vue?vue&type=template&id=6644741e&scoped=true"
import script from "./SaveList.vue?vue&type=script&lang=js"
export * from "./SaveList.vue?vue&type=script&lang=js"

import "./SaveList.vue?vue&type=style&index=0&id=6644741e&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6644741e"]])

export default __exports__